module.exports = __webpack_public_path__ + "assets/mysql.aed6f870.svg";